module.exports = __webpack_public_path__ + "static/img/son1_active.ca3cf69a.jpg";